import React, { useState, useEffect } from "react";
import Chart from 'react-apexcharts';
import loader from "../../Assets/loaderTransaparent.gif";
import timeConversion from  "../../Utilities/timeConversion";
import { eworkers,instances,instancesTime } from "../../Redux/actions/dashboard";
import "./index.css";

function Eworkers(props) {

    let [workers,setWorkers] = useState([]);
    let [count, setCount] = useState(0);
    let [totalInstances,setTotalInstances] =  useState(0);
    let [successInstances,setSuccessInstances] =  useState(0);
    let [failedInstances,setFailedInstances] =  useState(0);
    let [stoppedInstances,setStoppedInstances] =  useState(0);
    let [successInstancesTime,setSuccessInstancesTime] =  useState(0);
    let [loading,setLoading] = useState(false);
    let [chart,setChart]=useState([]);
    var options = {
      chart: {
      type: 'donut',
    },
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 200
        },
        legend: {
          position: 'bottom'
        }
      }
    }]
    };
    useEffect(() => {
      const fetchData = async () => {
          setLoading(true);
          let [data,total,time] = await Promise.all([eworkers() ,instances() ,instancesTime()])
          if(data && total && time && data.length > 0 ){
            let percentage =  [0, total.totalSuccessInstances ,total.totalStoppedInstances ,total.totalErroredInstances]
            setWorkers(data)
            setCount(data.length)
            setTotalInstances(total.totalInstances)
            setSuccessInstances(total.totalSuccessInstances)
            setFailedInstances(total.totalErroredInstances)
            setStoppedInstances(total.totalStoppedInstances)
            setSuccessInstancesTime(time.totalSuccessInstances)
            setChart(percentage)
          };
      setLoading(false);
    }
  
    fetchData();
    },[])
    
    return (
        <div className="main-content">
            <div className="total">
              <div className="row">
                  <div className="col-md-4 fix-wh-1">
                  <div  className="card-white">
                            <div className="data-block">
                                <div className="db-title">
                                  <p>E-worker’s machine ({count})</p>
                                </div>
                                <div className="list-table">
                                  <table className="table-list">
                                        <thead >
                                            <tr>
                                                <th>Machine</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead >
                                        <tbody>
                                          {workers.length > 0 ? workers.map((obj, ind) => { 
                                            return (
                                              <tr>
                                                  <td>{obj.worker_name}</td>
                                                  <td>{obj.instance_state ?(
                                                      obj.instance_state === "initializing" ? 
                                                        <span className="tag initializing">IDLE</span>
                                                          : 
                                                      obj.instance_state === "running" ? 
                                                        <span className="tag running">{obj.instance_state}</span>
                                                          :
                                                        <span className="tag stopped">{obj.instance_state}</span>
                                                      ):
                                                      (obj.queue_connection_status? 
                                                        obj.queue_connection_status==="DOWN"?
                                                        <span className="tag stopped">STOPPED</span>
                                                        :
                                                        obj.queue_connection_status==="IDLE"?
                                                        <span className="tag initializing">AVAILABLE</span>
                                                        :"-"
                                                        :
                                                        <span className="tag initializing">IDLE</span>
                                                      )}
                                                  </td>
                                              </tr>
                                            )}):loading ?
                                            <div className="main-content">
                                              <div style={{ textAlign: "center", marginTop: "15%" ,marginLeft:"90%"}}>
                                                <img src={loader} width="100" alt="loading"></img>
                                              </div>
                                            </div>:
                                            <div className="main-content">
                                              <div className="nodata-1">
                                                <p>You don't have any E-Worker Machines yet.</p>
                                              </div>
                                            </div>
                                          } 
                                        </tbody>
                                  </table>
                                </div>
                            </div>
                      </div>        
                  </div>
                  <div className="col-md-4 fix-wh-2">
                    <div  className="card-white">
                            <div className="data-block">
                                  <div className="db-title">
                                    <p>Instances</p>
                                  </div>
                                  {totalInstances > 0 ?
                                    <div>
                                      <div className="pie-chart-block">
                                          <Chart options={options} series={chart} type="donut"  height={150} style={{marginLeft:"20px"}}/> 
                                          {totalInstances?<div className="totalCount">{totalInstances} TASKS</div>:""}                                      </div>
                                        <div className="dc-stats">
                                            <div className="dc-text">
                                              <span className="round complete"></span>
                                              <p>{successInstances}</p>
                                              <span>COMPLETED</span>
                                            </div>
                                            <div className="dc-text">
                                              <span className="round stop"></span>
                                              <p>{stoppedInstances}</p>
                                              <span>STOPPED</span>
                                            </div>
                                            <div className="dc-text">
                                              <span className="round error"></span>
                                              <p>{failedInstances}</p>
                                              <span>FAULTED</span>
                                            </div>
                                        </div>
                                      </div>
                                    :!loading ? 
                                    <div className="main-content">
                                      <div className="nodata-2">
                                        <p>You don't have any Instances yet.</p>
                                      </div>
                                    </div>:
                                    <div className="main-content">
                                      <div style={{ textAlign: "center", marginTop: "20%",marginLeft:"20%" }}>
                                        <img src={loader} width="100" alt="loading"></img>
                                      </div>
                                    </div>
                                  } 
                              </div>
                      </div>
                </div>
                <div className="col-md-4 fix-wh-3">
                    <div  className="card-white">
                        <div className="data-block">
                          {!loading ?
                            <div className="chart-content">
                              <div className="d-flex prc-block">
                                <div className="prc-inner">
                                  <h3>{successInstancesTime?timeConversion(successInstancesTime):"0"}</h3>
                                  <span>Machine  Hours</span>
                                </div>
                                <div className="prc-inner">
                                  <h3>{totalInstances}</h3>
                                  <span>Automated Instances</span>
                                </div>
                              </div>
                            </div>
                            :
                            <div className="main-content">
                              <div style={{ textAlign: "center",marginLeft:"20%" }}>
                                <img src={loader} width="100" alt="loading" style={{marginTop: "40%"}}></img>
                              </div>
                            </div>
                          }
                        </div>
                    </div>        
                </div>
            </div>
          </div>
        </div>
    );
}

export default Eworkers;
